module.exports = __webpack_public_path__ + "img/Gauche.eb29292b.svg";